import React, { Component } from "react";
import { Table, Card, Empty } from "antd";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { mutliDragAwareReorder, multiSelectTo as multiSelect } from "./Utils";
import "./style.css";
import { withLogisticRoutes } from "../../../shared/containers/containerLogisticRoutes";
import { states } from "../../../reducers/queriesStates";

const PRIMARY_BUTTON_NUMBER = 0;

class RouteControlPointsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageSize: 10000,
      selectedTaskIds: [],
      draggingTaskId: null,
      entities: {
        tasks: [],
        columnIds: ["todo"],
        columns: {
          todo: {
            id: "todo",
            title: "To do",
            taskIds: [],
          },
        },
      },
    };
  }

  componentDidMount() {
    const { logisticSelectedRoute } = this.props;
    const { entities } = this.state;

    entities.tasks = logisticSelectedRoute.controlPoints.map((x) => {
      return { id: `${x.number}`, title: x.title, address: x.address, controlPointId: x.id };
    });

    entities.columns.todo.taskIds = logisticSelectedRoute.controlPoints.map((x) => {
      return `${x.number}`;
    });

    this.setState({ entities });
  }

  componentDidUpdate(preProps) {
    const { logisticSelectedRoute, logisticSetNumberControlPointRouteDataState } = this.props;
    const { entities } = this.state;

    if (
      logisticSetNumberControlPointRouteDataState === states.READY &&
      preProps.logisticSetNumberControlPointRouteDataState === states.REQUEST
    ) {
      entities.tasks = logisticSelectedRoute.controlPoints.map((x) => {
        return { id: `${x.number}`, title: x.title, address: x.address, controlPointId: x.id };
      });

      entities.columns.todo.taskIds = logisticSelectedRoute.controlPoints.map((x) => {
        return `${x.number}`;
      });

      this.setState({ entities, selectedTaskIds: [], draggingTaskId: null });
    }
  }

  render() {
    const { pageSize, selectedTaskIds, draggingTaskId, entities } = this.state;

    const tableColumns = [
      {
        title: "Наименование",
        dataIndex: "title",
      },
      {
        title: "Адрес",
        dataIndex: "address",
      },
    ];

    const onWindowClick = (e) => {
      if (e.defaultPrevented) {
        return;
      }

      this.setState({ selectedTaskIds: [] });
    };

    const onWindowKeyDown = (e) => {
      if (e.defaultPrevented) {
        return;
      }

      if (e.key === "Escape") {
        this.setState({ selectedTaskIds: [] });
      }
    };

    const onWindowTouchEnd = (e) => {
      if (e.defaultPrevented) {
        return;
      }

      this.setState({ selectedTaskIds: [] });
    };

    window.addEventListener("click", onWindowClick);
    window.addEventListener("keydown", onWindowKeyDown);
    window.addEventListener("touchend", onWindowTouchEnd);

    const DroppableTableBody = ({ columnId, tasks, ...props }) => {
      return (
        <Droppable droppableId={columnId}>
          {(provided, snapshot) => <tbody ref={provided.innerRef} {...props} {...provided.droppableProps}></tbody>}
        </Droppable>
      );
    };

    const DraggableTableRow = ({ index, record, columnId, tasks, ...props }) => {
      if (!tasks.length) {
        return (
          <tr className="ant-table-placeholder row-item" {...props}>
            <td colSpan={tableColumns.length} className="ant-table-cell">
              <div className="ant-empty ant-empty-normal">
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              </div>
            </td>
          </tr>
        );
      }

      const isSelected = selectedTaskIds.some((selectedTaskId) => selectedTaskId === record.id);
      const isGhosting = isSelected && Boolean(draggingTaskId) && draggingTaskId !== record.id;

      return (
        <Draggable key={props["data-row-key"]} draggableId={props["data-row-key"].toString()} index={index}>
          {(provided, snapshot) => {
            return (
              <tr
                ref={provided.innerRef}
                {...props}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                className={`row-item ${isSelected ? "row-selected" : ""} ${isGhosting ? "row-ghosting" : ""} ${
                  snapshot.isDragging ? "row-dragging" : ""
                }`}
              ></tr>
            );
          }}
        </Draggable>
      );
    };

    const getTasks = (entities, id) => {
      return entities.columns[id].taskIds.map((taskId) => entities.tasks.find((item) => item.id === taskId));
    };

    const onBeforeCapture = (start) => {
      const draggableId = start.draggableId;
      const selected = selectedTaskIds.find((taskId) => taskId === draggableId);

      if (!selected) {
        this.setState({ selectedTaskIds: [] });
      }
      this.setState({ draggingTaskId: draggableId });
    };

    const onDragEnd = (result) => {
      const destination = result.destination;
      const source = result.source;

      // nothing to do
      if (!destination || result.reason === "CANCEL") {
        this.setState({ draggingTaskId: null });

        return;
      }

      const processed = mutliDragAwareReorder({
        entities,
        selectedTaskIds,
        source,
        destination,
      });

      this.setState({ draggingTaskId: null, entities: processed.entities });

      const numbers =
        selectedTaskIds.length > 0
          ? selectedTaskIds
              .map((x) => {
                return parseInt(x);
              })
              .sort(function (a, b) {
                return a - b;
              })
          : [parseInt(result.draggableId)];

      const number = processed.entities.columns.todo.taskIds.indexOf(`${numbers[0]}`) + 1;
      let controlPoints = [];

      numbers.forEach((x) => {
        processed.entities.tasks.forEach((t) => {
          if (parseInt(t.id) === x) {
            controlPoints = controlPoints.concat([t.controlPointId]);
          }
        });
      });

      const { logisticSelectedRoute, onSetNumberControlPointRoute } = this.props;
      onSetNumberControlPointRoute({ routeId: logisticSelectedRoute.id, start: number, controlPoints });
    };

    const toggleSelection = (taskId) => {
      const wasSelected = selectedTaskIds.includes(taskId);

      const newTaskIds = (() => {
        if (!wasSelected) {
          return [taskId];
        }

        if (selectedTaskIds.length > 1) {
          return [taskId];
        }

        return [];
      })();

      this.setState({ selectedTaskIds: newTaskIds });
    };

    const toggleSelectionInGroup = (taskId) => {
      const index = selectedTaskIds.indexOf(taskId);

      if (index === -1) {
        this.setState({ selectedTaskIds: [...selectedTaskIds, taskId] });

        return;
      }

      const shallow = [...selectedTaskIds];
      shallow.splice(index, 1);

      this.setState({ selectedTaskIds: shallow });
    };

    const multiSelectTo = (newTaskId) => {
      const updated = multiSelect(entities, selectedTaskIds, newTaskId);

      if (updated == null) {
        return;
      }

      this.setState({ selectedTaskIds: updated });
    };

    const onClickRow = (e, record) => {
      if (e.defaultPrevented) {
        return;
      }

      if (e.button !== PRIMARY_BUTTON_NUMBER) {
        return;
      }

      e.preventDefault();
      performAction(e, record);
    };

    const onTouchEndRow = (e, record) => {
      if (e.defaultPrevented) {
        return;
      }

      e.preventDefault();
      toggleSelectionInGroup(record.id);
    };

    const wasToggleInSelectionGroupKeyUsed = (e) => {
      const isUsingWindows = navigator.platform.indexOf("Win") >= 0;
      return isUsingWindows ? e.ctrlKey : e.metaKey;
    };

    const wasMultiSelectKeyUsed = (e) => e.shiftKey;

    const performAction = (e, record) => {
      if (wasToggleInSelectionGroupKeyUsed(e)) {
        toggleSelectionInGroup(record.id);
        return;
      }

      if (wasMultiSelectKeyUsed(e)) {
        multiSelectTo(record.id);
        return;
      }

      toggleSelection(record.id);
    };

    const handleTableChange = (pagination, filters, sorter) => {
      const { pageSize } = pagination;

      this.setState({ pageSize });
    };

    return (
      <>
        <Card className={`c-multi-drag-table ${draggingTaskId ? "is-dragging" : ""}`}>
          <DragDropContext onBeforeCapture={onBeforeCapture} onDragEnd={onDragEnd}>
            {entities.columnIds.map((id) => (
              <Table
                dataSource={getTasks(entities, id)}
                columns={tableColumns}
                rowKey="id"
                pagination={{
                  pageSize,

                  showSizeChanger: true,
                  size: "small",
                }}
                components={{
                  body: {
                    wrapper: (val) =>
                      DroppableTableBody({
                        columnId: entities.columns[id].id,
                        tasks: getTasks(entities, id),
                        ...val,
                      }),
                    row: (val) =>
                      DraggableTableRow({
                        tasks: getTasks(entities, id),
                        ...val,
                      }),
                  },
                }}
                onRow={(record, index) => ({
                  index,
                  record,
                  onClick: (e) => onClickRow(e, record),
                  onTouchEnd: (e) => onTouchEndRow(e, record),
                })}
                onChange={handleTableChange}
              />
            ))}
          </DragDropContext>
        </Card>
      </>
    );
  }
}

export default withLogisticRoutes(React.memo(RouteControlPointsList));
